import * as Yup from "yup"




const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

let validationSchema = {
  email: Yup.string().email("Invalid email address").required("Email address is required"),
  rewardId: Yup.string().required("Please select a reward"),
  termsAccepted: Yup.bool().required("Required Field").oneOf([true], "Required Field"),
  eighteenOrOver: Yup.bool().required("Required Field").oneOf([true], "Required Field") // added to the regular validation schema because its in every RV form
}

let nameValidation = {
  firstName: Yup.string()
  .matches(/^[A-Za-z À-ÿ-']*$/, "Please enter valid name")
  .max(80, "Cannot exceed 80 characters.")
  .trim()
  .required("Required Field"),

lastName: Yup.string()
  .matches(/^[A-Za-z À-ÿ-']*$/, "Please enter valid name")
  .max(80, "Cannot exceed 80 characters.")
  .trim()
  .required("Required Field"),
}

let addressValidation = {
  address1: Yup.string().required("Address is required"),

  address2: Yup.string(),

  city: Yup.string().required("City is required"),

  state: Yup.string().required("State is required"),

  postalCode: Yup.string()
    .matches(/^[0-9]+$/, "Must be only digits")
    .min(5, "Must be exactly 5 digits")
    .max(5, "Must be exactly 5 digits")
    .required("Postal Code is required"),
}

let phoneValidation = {
  phoneNumber: Yup.string().matches(phoneRegExp, "Phone number is not valid").required("Phone number is required"),
}

let confirmationValidation = {
  customConfirmation: Yup.bool().required("Required Field").oneOf([true], "Required Field")
}

const returnDynamicValidation = (nameRequired, addressRequired, phoneRequired, customConfirmationExists) => {
  return {
    ...validationSchema,
    ...(addressRequired && addressValidation),
    ...(phoneRequired && phoneValidation),
    ...(customConfirmationExists && confirmationValidation),
    ...(nameRequired && nameValidation)
  }
}
export { returnDynamicValidation, phoneRegExp, validationSchema, addressValidation, phoneValidation, confirmationValidation }
